<template>
  <div class="layout">
    <div class="bg-box"></div>
    <div class="nav-container">
      <nav-bar />
    </div>
    <div class="main-container">
      <app-bar />
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Appbar from "./components/Appbar.vue";
import Bottom from "@/components/Bottom.vue";
export default {
  computed: {},
  components: {
    "nav-bar": Navbar,
    "app-bar": Appbar,
    Bottom
  },
  data() {
    return {
      isHome: true
    };
  },
  methods: {}
};
</script>


<style scoped>
.layout {
  position: relative;
  background: #f5f7fa;
}
.bg-box {
  position: fixed;
  width: 100%;
  top: 0;
  height: 315px;
  background: #002352 url("~@/assets/index-bg.png") no-repeat top;
  /* z-index: 8; */
}
.nav-container {
  margin: 0 auto;
  width: 1200px;
  position: relative;
  /* z-index: 10; */
}
.main-container {
  position: relative;
  margin: 0 auto;
  width: 1200px;
  display: flex;
  min-height: calc(100vh - 118px);
}
</style>
